/** New-run composer: the brief field, launch chrome, and the AttachmentPicker. */

export const newRun = {
  backToFlows: 'Flows',
  missingFlowId: 'Missing flow id.',
  flowNotAvailable: 'This flow is not available to your company.',
  briefLabel: 'What do you need?',
  briefPlaceholder: 'Describe the task in your own words…',
  launch: 'Launch',
  mayPauseHint: 'This flow may pause to ask you a question.',

  // A run that failed before anything came back
  notStarted: 'This run did not start.',
  unreachable: 'The portal could not be reached. Check your connection and try again.',
  interrupted:
    'The connection dropped while the run was working. It may still be running: open it to see where it stands.',
  interruptedEarly:
    'The connection dropped as the run began. It may still be running: look in History before starting it again, so it does not run twice.',
  backToRequest: 'Back to your request',
  openRun: 'Open this run',
  openHistory: 'Open History',

  // AttachmentPicker
  attachTitle: 'Attachments',
  attachMeterEmpty: (cap: string) => `0 attached · ${cap} cap`,
  attachMeterUsed: (n: number, used: string, cap: string) => `${n} attached · ${used} / ${cap}`,
  attachDropzoneAria: 'Add attachments — drop files or press Enter to browse',
  attachDropzoneHint: (cap: string) => `Drop files here or tap to browse — up to ${cap} total`,
  attachRemove: (name: string) => `Remove ${name}`,
  attachFolderUnsupported: 'Folder drops are not supported. Drop individual files.',
  attachPerFileExceeded: (name: string, cap: string) => `"${name}" exceeds the per-file cap of ${cap}.`,
  attachTotalExceeded: (total: string, cap: string) => `Total ${total} would exceed the ${cap} cap.`,
  attachTooMany: (count: number, max: number) => `${count} files — at most ${max} can be attached.`,
  attachDropzoneHintPlain: 'Drop files here or tap to browse',
  attachUploading: (name: string) => `Uploading ${name}`,
  attachRetry: (name: string) => `Retry ${name}`,
  attachFailed: 'An upload failed. Retry it, or remove the file.',
  attachWaiting: 'Waiting for the files to finish uploading…'
}
